import React, {useEffect} from "react";
import {campaignFormActions} from "../../../store/actions/campaignFormAction";
import {connect} from "react-redux";
import {useForm} from "react-hook-form";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import ISPMultiSelect from "./ISPMultiSelect";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton, useTheme} from "@mui/material";
import useCustomStyles from "../../utils/UseCustomStyles";

const customStyles = (theme) => ({
    root: {
        marginTop: theme.spacing(1),
        padding: "12px 10px",
        backgroundColor: theme.palette.background.darkBlue,
        borderRadius: 4
    },
    title: {
        paddingTop: 4,
        fontSize: 14,
        fontWeight: 600
    },
    radio: {
        '&$checked': {
            color: theme.palette.error.light
        }
    },
    checked: {},
    deleteButton: {
        color: theme.palette.error.dark
    },
    addConditionButton: {
        textTransform: "none",
        padding: "2px 8px"
    }
});

function ISP(props) {
    const theme = useTheme();
    const classes = useCustomStyles(customStyles, theme);
    const {campaignFormState: {flow, selectedRuleNumber, selectedRule}} = props;

    const {control, setValue, reset, getValues} = useForm({
        defaultValues: {
            ispCondition: "is",
            ispIncludeEmptyValue: false,
            ispValues: []
        }
    });

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    useEffect(() => {
        let condition = selectedRule?.conditions?.isp?.condition;
        if (condition === undefined || condition === "") {
            reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRule, selectedRuleNumber, selectedRule?.conditions?.isp?.condition]);

    useEffect(() => {
        let type = flow?.rules[selectedRuleNumber]?.conditions?.isp;
        if (selectedRule !== null && type?.condition !== "") {
            setValue("ispCondition", type?.condition);
            setValue("ispIncludeEmptyValue", type?.includeEmptyValue);
            setValue("ispValues", type?.values !== null ? type?.values : []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRuleNumber, selectedRule, flow.rules]);

    const updateCondition = () => {
        props.updateCondition(
            props.campaignFormState.selectedRuleNumber,
            "isp",
            getValues("ispCondition"),
            getValues("ispIncludeEmptyValue"),
            getValues("ispValues")
        );
    };

    const removeCondition = () => {
        props.updateCondition(props.campaignFormState.selectedRuleNumber, "isp", "", false, null);
    };

    const addCondition = () => {
        props.updateCondition(props.campaignFormState.selectedRuleNumber, "isp", "is", false, []);
    };

    const renderAddCondition = () => {
        let condition = selectedRule?.conditions?.isp?.condition;
        if (condition === "" || condition === undefined) {
            return (
                <Box display="flex" flexDirection="row">
                    <Box flexGrow={1} className={classes?.title}>
                        <span>ISP</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            className={classes?.addConditionButton}
                            onClick={addCondition}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        let condition = selectedRule?.conditions?.isp?.condition;
        if (condition !== "" && condition !== undefined) {
            return (
                <>
                    <Box mb={1} display="flex" flexDirection="row">
                        <Box flexGrow={1} className={classes?.title}>ISP</Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size={"small"}
                                className={classes?.deleteButton}
                                onClick={removeCondition}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            defaultValue="is"
                            control={control}
                            options={radioConditions}
                            name="ispCondition"
                            label="conditions"
                            updateOnChange={updateCondition}
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name="ispIncludeEmptyValue"
                            updateOnChange={updateCondition}
                        />
                    </Box>
                    <Box>
                        <ISPMultiSelect
                            control={control}
                            inputName={"ispValues"}
                            inputLabel={"Select or search for ISP"}
                            updateOnChange={updateCondition}
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <Box display="flex" flexDirection="column" className={classes?.root}>
            {renderAddCondition()}
            {renderConditionBox()}
        </Box>
    );
}

const mapStateToProps = (state) => ({
    campaignFormState: state.campaignForm,
});

const mapDispatchToProps = {
    updateCondition: campaignFormActions.updateCondition,
};

export default connect(mapStateToProps, mapDispatchToProps)(ISP);